import { PINTO_SITEURL, SERVICE_SITEURL } from '@/constants';
import axios from 'axios';

const apiBlog = {
    news: {
        get(params) {
            return axios.get(`${SERVICE_SITEURL}/wp-json/wp/v2/news`, {
                params: params
            });
        }
    },
    pinto: {
        get(params) {
            return axios.get(
                `${PINTO_SITEURL}/wp-json/wp/v2/blog/?_embed&blog_cat=2`,
                {
                    params: params
                }
            );
        }
    }
};
export default apiBlog;
